import { render, staticRenderFns } from "./Volume.vue?vue&type=template&id=3c3c5e5c&scoped=true&"
import script from "./Volume.vue?vue&type=script&lang=js&"
export * from "./Volume.vue?vue&type=script&lang=js&"
import style0 from "./Volume.vue?vue&type=style&index=0&id=3c3c5e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3c5e5c",
  null
  
)

export default component.exports